const repos = {
  show: false,
  heading: "Recent Projects",
  gitHubUsername: "shubhamguptahere",
  reposLength: 4,
  specificRepos: [],
};
//
// Leadership SECTION
const leadership = {
  show: false, // changed from false -> true to display the Leadership section
  heading: "Leadership",
  message:
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Vitae auctor eu augue ut lectus arcu bibendum at varius. Libero justo laoreet sit amet cursus sit amet. Imperdiet dui accumsan sit amet nulla facilisi morbi. At auctor urna nunc id. Iaculis urna id volutpat lacus laoreet non curabitur gravida. Et magnis dis parturient montes nascetur ridiculus mus mauris. In nisl nisi scelerisque eu ultrices vitae auctor. Mattis nunc sed blandit libero volutpat sed cras ornare. Pulvinar neque laoreet suspendisse interdum consectetur libero.",
  images: [
    {
      img: require("../editable-stuff/prof.jpg"),
      label: "First slide label",
      paragraph: "Nulla vitae elit libero, a pharetra augue mollis interdum."
    },
    {
      img: require("../editable-stuff/prof.jpg"),
      label: "Second slide label",
      paragraph: "Nulla vitae elit libero, a pharetra augue mollis interdum."
    },
  ],
  imageSize: {
    width:"615",
    height:"450"
  }
};

const navBar = {
  show: true,
};

// Main Body SECTION
const mainBody = {
  gradientColors: "#4484ce, #1ad7c0, #ff9b11, #9b59b6, #ff7f7f, #ecf0f1",
  firstName: "Shubham",
  middleName: "",
  lastName: "Gupta",
  message: "Data Platform Lead | 8+ Years | Architecting Scalable Cloud Solutions with AWS, Databricks & Apache Airflow | Agile Certified (CSPO®, RPO™)",
  icons: [
    {
      image: "fa-github",
      url: "https://github.com/shubhamguptahere",
    },
    {
      image: "fa-facebook",
      url: "https://www.facebook.com/shubhmgupta11",
    },
    {
      image: "fa-instagram",
      url: "https://www.instagram.com/theshubhmgupta/",
    },
    {
      image: "fa-linkedin",
      url: "https://www.linkedin.com/in/shubhamsg/",
    },
    {
      image: "fa-twitter",
      url: "https://www.twitter.com/iamsamsg/",
    },
  ],
};

const about = {
  show: true,
  heading: "About Me",
  imageLink: require("../editable-stuff/prof.jpg"),
  imageSize: 376,
  message:
    "Data Platform Engineer with 8+ years driving $1M+ cost savings and 85%+ efficiency improvements through scalable cloud-native platforms. Expert in AWS, Apache Airflow, Databricks, Python, and Terraform. Proven leadership in team scaling, mentorship, and cross-functional collaboration. Specialized in designing serverless architectures, data ingestion pipelines, ML automation, and enterprise data governance. Recognized with Employee of the Year, Enterprise Innovation Award, and 40+ culture badges. Passionate about transforming complex data challenges into efficient, reliable systems.",
  resume: "https://drive.google.com/file/d/1O73lSe8e7zzGvFWJiKmlAbRlYpTBL8zJ/view?usp=share_link",
};

// PROFESSIONAL EXPERIENCE SECTION
const experiences = {
  show: true,
  heading: "Professional Experience",
  data: [
    {
      company: "John Deere - Blue River Technology",
      logoUrl: require("../assets/img/brt.png"),
      title: "Data Platform Lead",
      employmentType: "Full-Time",
      totalDuration: "2024 - Present",
      dateRange: "July 2024 – Present",
      location: "Pune, Maharashtra",
      summary: "Architected scalable Common Ingestion Platform and led team growth.",
      description: "Architected scalable Common Ingestion Platform reducing pipeline complexity by 70%+. Built ROI and Pre-Labeling pipelines saving $380K+. Led team from 1 to 6 engineers. Designed analytics dashboards and PVS 3.0 serverless system.",
      skillsSummary: "AWS, Databricks, Airflow, Serverless, Cloud Automation, DevOps, Architecture Design (System), ETL, Containerization, Project Management, Technical Leadership)",
    },
    {
      company: "John Deere",
      logoUrl: require("../assets/img/johndeere.png"),
      title: "Data Engineering Lead I",
      employmentType: "Full-Time",
      totalDuration: "2022 - 2024",
      dateRange: "Nov 2022 – July 2024",
      location: "Pune, Maharashtra",
      summary: "Designed high-throughput serverless ingestion pipelines.",
      description:
        "Designed serverless Nebula Data Ingestion Pipeline for 20+ CVML projects handling 1TB+ daily workload, achieving 20x onboarding reduction and $500K+ cost savings. Built Delta Lake integrations and centralized workflow management.",
      skillsSummary: "AWS Step Functions, Lambda, Databricks, Database Management, Spark, Unity Catalog, Orchestration, Scripting",
    },
    {
      company: "John Deere",
      logoUrl: require("../assets/img/johndeere.png"),
      title: "Senior Software Engineer",
      employmentType: "Full-Time",
      totalDuration: "2018 - 2022",
      dateRange: "July 2018 – Nov 2022",
      location: "Pune, Maharashtra",
      summary: "Built perception and automation tools for CV/ML workflows.",
      description:
        "Contributed to robotics, embedded systems, and perception workflows using ROS/Gazebo. Developed AI scoring and validation tools for CV/ML models. Designed cloud-native automation and verification systems (PVS foundations).",
      skillsSummary: "Python, Embedded Systems, C++, ROS, Computer Vision",
    },
  ],
};

// KEY PROJECTS SECTION
const projects = {
  show: true,
  heading: "Selected Architecture & Platform Initiatives",
  data: [
    {
      projectName: "Serverless Ingestion: Scalable Two-Phase Data Pipeline",
      desc: "Event-driven pipeline for 20+ CVML projects handling 1TB+ daily workload, achieving 200x ingestion concurrency and 20x onboarding acceleration using AWS Lambda, Step Functions, and Terraform.",
    },
//    {
//      projectName: "Nebula Serverless Ingestion",
//      desc: "Event-driven pipeline for 20+ CVML projects handling 1TB+ daily workload, achieving 200x ingestion concurrency and 20x onboarding acceleration using AWS Lambda, Step Functions, and Terraform.",
//    },
    {
      projectName: "Common Ingest Framework",
      desc: "Unified multi-tenant data ingestion reducing pipeline complexity by 70% and onboarding from weeks to hours across BRT and ISG ecosystems.",
    },
    {
      projectName: "Pre-Labeling & ROI Pipelines",
      desc: "Intelligent automation workflows achieving 66% labeling time reduction and $380K+ annual cost savings via Databricks ML and smart filtering.",
    },
    {
      projectName: "PVS 3.0",
      desc: "Serverless CV/ML validation platform enabling parallel processing for 2TB+ datasets, reducing processing time from 8+ hours to minutes.",
    },
    {
      projectName: "Aletheia Analytics Platform",
      desc: "Feature-rich dataset management with unified search, analytics dashboards, and Labelbox parallelization improving efficiency by 65%+.",
    },
    {
      projectName: "Data Governance",
      desc: "Migrated 9+ workflows to Unity Catalog, achieving 100% dataset auditability and enterprise-grade reliability across 4 regions.",
    },
  ],
};

// SKILLS SECTION
const skills = {
  show: true,
  heading: "Skills",
  hardSkills: [
    { name: "Python", value: 95 },
    { name: "SQL", value: 80 },
    { name: "AWS (Lambda, S3, ECS, Step Functions)", value: 95 },
    { name: "Databricks & Spark", value: 80 },
    { name: "Apache Airflow", value: 75 },
    { name: "Terraform & IaC", value: 80 },
    { name: "Docker & Kubernetes", value: 70 },
    { name: "MongoDB & Delta Lake", value: 75 },
  ],
  softSkills: [
    { name: "Leadership", value: 90 },
    { name: "Cross-functional Collaboration", value: 95 },
    { name: "Technical Architecture Design", value: 90 },
    { name: "Mentorship", value: 85 },
    { name: "Problem Solving", value: 95 },
    { name: "Communication", value: 90 },
    { name: "Agile Methodologies", value: 85 },
    { name: "Innovation", value: 90 },
  ],
};

// CERTIFICATIONS SECTION
const certifications = {
  show: false,
  heading: "Certifications & Awards",
  data: [
    // You can provide a string (will show initials placeholder) or an object with optional image and link
    // Example with local image: { name: "AWS Certified Data Engineer – Associate", image: require("../editable-stuff/aws-badge.png"), link: "https://example.com/aws" },
    // Example with external image URL: { name: "CSPO®", image: "https://example.com/cspo-badge.png", link: "https://example.com/cspo-cert" },

    // For local images that live in `src/`, use require() so the bundler includes them
    // If you have a local JSON badge file (e.g. src/assets/badges/Badge_Databricks.json),
    // require it into the `data` field so the UI can pretty-print the JSON object.
    { name: "AWS Certified Data Engineer - Associate", image: require("../assets/badges/1.png"), link: null },
    { name: "Cloud Native Spark Migration - Certificate", image: require("../assets/badges/2.png"), link: null},
    { name: "Certified Scrum Product Owner (CSPO®)", image: require("../assets/badges/6.png"), link: null },
    { name: "Registered Product Owner (RPO™)", image: require("../assets/badges/3.png"), link: null },
    { name: "Google Project Management Professional", image: require("../assets/badges/4.png"), link: null },
    { name: "AWS Cloud Technical Essentials", image: require("../assets/badges/5_1.png")},
    { name: "MATLAB DL ON-RAMP ", image: require("../assets/badges/7.png")},
    { name: "Employee of the Year Award", image: require("../assets/badges/9_2.png")},
//    { name: "Enterprise Innovation Award", image: null, link: null },
    { name: "Best Efficiency Award", image: require("../assets/badges/9_2.png"), link: null },
    { name: "Cloud Value Maximization Award", image: require("../assets/badges/9_2.png"), link: null },
    { name: "Commendable Contribution Individual Award", image: require("../assets/badges/9_2.png"), link: null },
    { name: "Commendable Contribution Team Award", image: require("../assets/badges/9_2.png"), link: null },
  ],
};

// CONTACT SECTION
const getInTouch = {
  show: true,
  heading: "Get In Touch",
  message:
    "Passionate about solving complex data challenges and building scalable systems. I thrive in collaborative, innovative environments and seek to drive organizational impact through technical excellence and leadership. Let's connect to discuss how we can create transformative solutions together.",
  email: "shubham9646@gmail.com",
  phone: "+91-9877-595-351",
};

export {
  navBar,
  mainBody,
  about,
  repos,
  experiences,
  projects,
  skills,
  leadership,
  certifications,
  getInTouch
};
